import AppLayout from "../components/layout/AppLayout";
import LiveRakeOperation from "../components/rake/LiveRakeOperation";

export default function LiveRakePage() {
  return (
    <AppLayout hideDateFilter>
      <LiveRakeOperation />
    </AppLayout>
  );
}
